import React from 'react';
import PropTypes from 'prop-types';

const TopHeaderMenuContainer = ({ children, name, backgroundColor }) => (
  <nav id={name} className={`w-full flex flex-row-reverse desktop:flex-row items-center justify-start tablet:justify-end bg-${backgroundColor}`}>
    { children }
  </nav>
);

TopHeaderMenuContainer.propTypes = {
  name: PropTypes.string.isRequired,
  children: PropTypes.shape().isRequired,
  backgroundColor: PropTypes.string,
};

TopHeaderMenuContainer.defaultProps = {
  backgroundColor: 'white',
};

export default TopHeaderMenuContainer;
